import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { NotificationDialogComponent } from "./notification-dialog.component";
import { NotificationHandler, NotificationLevel } from "../notification-handler";
import { Injectable } from "@angular/core";

@Injectable()
export class DialogNotificationHandler extends NotificationHandler {

  constructor(private dialog: MatDialog) {
    super();
  }

  handle(level: NotificationLevel, title: string, message: string): void {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.maxWidth = '750px';
    dialogConfig.data = {
      level,
      title,
      message
    };

    this.dialog.open(NotificationDialogComponent, dialogConfig);
  }

}
